import { createSelector } from 'reselect';
import get from 'lodash/get';
import moment from 'moment-timezone';
import { SCOPE as commonSCOPE } from '@store/common/types';
import { SCOPE as dimensionTablesSCOPE } from '@store/dimensionTables/types';
import { selector as dimensionContainerSelector } from '@store/dimensionContainer';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import { chartIntervalSelector } from '../trends/birdChart/selectors';
import { SCOPE } from './types';

const commonSelector = (store) => get(store, commonSCOPE);
const dimensionTablesSelector = (store) => get(store, dimensionTablesSCOPE);
const selector = (state) => state[SCOPE].comparison;

export default selector;

export const selectedCompareMetricsCountSelector = createSelector(
  selector,
  (comparisonStore) => comparisonStore.metricList.length,
);

export const savedFiltersSelector = createSelector(
  selector,
  (comparisonStore) => comparisonStore.savedFilters,
);

export const metricListSelector = createSelector(
  selector,
  (comparisonStore) => comparisonStore.metricList,
);

export const compareIntervalSelector = createSelector(
  selector,
  (comparisonStore) => comparisonStore.interval,
);

export const compareConfigSelector = createSelector(
  commonSelector,
  dimensionTablesSelector,
  selectedMetricSelector,
  selector,
  dimensionContainerSelector,
  chartIntervalSelector,
  (common, dimensionTables, selectedMetric, comparison, dimensionContainer, chartInterval) => {
    const { showDiagChart } = dimensionContainer;
    const commonInterval = common.interval;
    let interval: any = null;

    // use diag zoom or slice interval if it's set
    if (
      showDiagChart !== null &&
      showDiagChart &&
      !(
        // chart interval is same as main then use main as is (with shortcuts)
        (
          moment(chartInterval.from).isSame(commonInterval.from) &&
          moment(chartInterval.to).isSame(commonInterval.to)
        )
      )
    ) {
      interval = {
        from: moment(chartInterval.from).format(),
        to: moment(chartInterval.to).format(),
      };

      // carry over granularity to compare
      // if the main interval value is not applicable to slice
      // then compare init code will fix the value
      if (common.interval.granularity) {
        interval.granularity = commonInterval.granularity;
      }
    } else {
      interval = { ...commonInterval };
    }

    const config = {
      interval: interval,
      lastInterval: interval,
      appliedFilters: common.appliedFilters,
      dimensionSortByMetric: dimensionTables.dimensionSortByMetric,
      selectedMetric,
      filterBars: [],
      savedFilters: comparison.savedFilters,
      metricList: comparison.metricList,
      // zoomInterval: comparison.zoomInterval,
    };

    return config;
  },
);

export const compareDataSelector = createSelector(selector, (comparison) => comparison.compareData);

export const filterIndicesSelector = createSelector(compareDataSelector, (compareData) => {
  return compareData ? compareData.filterIndices : [];
});

export const compareZoomDataSelector = createSelector(
  selector,
  (comparison) => comparison.compareZoomData,
);

export const compareLoaderSelector = createSelector(selector, (comparison) => comparison.loader);

export const activeEditIdSelector = createSelector(
  selector,
  (comparison) => comparison.activeEditId,
);

export const summaryTableDataSelector = createSelector(
  compareDataSelector,
  ({ metrics, filterMetaList, totalObj, colors }) => {
    const data: any = [];

    try {
      for (let i = 0; i < filterMetaList.length; i += 1) {
        const row = { filter: filterMetaList[i].name, color: colors[i] };
        metrics.forEach((m) => {
          row[m] = get(totalObj, [m, i], 0);
        });
        data.push(row);
      }
    } catch (err) {
      // console.error('summary table parse error', err);
    }

    return { metrics, data };
  },
);
